import React, { PropsWithChildren, ComponentPropsWithoutRef } from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

type NoteProps = {
  classes?: string
} & ComponentPropsWithoutRef<'div'>

function Note({ children, classes, ...props }: PropsWithChildren<NoteProps>) {
  return (
    <div className={classNames(styles.note, classes)} {...props}>
      {children}
    </div>
  )
}

export default Note
